export const settings = {
    //enableSocket 判断是否需要经过socket中转操作, socket一般为巴展需求, socket
    enableSocket: false,
    enableDebug: false,
    socketPort: 9091,
    default: {
        socketServer: '192.168.1.109'
        // apiServer: 'http://192.168.1.244:3000'
    },
    d13: {
        socketServer: '192.168.1.213'
        // apiServer: 'http://192.168.1.244:3000'
    },
    local: {
        socketServer: 'localhost'
        // apiServer: 'http://192.168.1.244:3000'
    },
    raspberry: {
        socketServer: '192.168.1.168'
        // apiServer: 'http://192.168.1.244:3000'
    },
    f1: {
        socketServer: '192.168.1.168'
        // apiServer: 'http://192.168.1.244:3000'
    },
    A: {
        socketServer: 'localhost',
    },
    B: {

    },
    C: {

    },
    D: {
        socketServer: 'localhost',
    },
    N: {
        socketServer: 'localhost',
    },
    O: {
        socketServer: 'localhost',
    },
    p: {
        socketServer: '192.168.1.245'
        // apiServer: 'http://192.168.1.244:3000'
    },
    
    S: {
        socketServer: 'localhost',
    },
    events: [
        'a','b','c','d1','d2','e','f','j','k','l','m','n','o','p','s','test'
    ]
}

export const currentConfig = 'D'
//export const currentConfig = 'local'
// export const currentConfig = 'd13'
//export const currentConfig = 'f1'
//export const currentConfig = 'raspberry'